import { Loader, PageHeader } from '@fukuri-admins/ui/common';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { Suspense } from 'react';
import { useGetPartnerAdminsPartnerFeatureFlags } from '~/hooks';
import { UserList } from '~/features/UserList';
import { UserListBankAccount } from '~/features/UserListBankAccount';
import styles from './styles.module.scss';

/**
 * 利用者一覧コンテンツ
 *
 * partner_feature_flag.bank_account の ON/OFF で表示する Feature を切り替える。
 * `useGetPartnerAdminsPartnerFeatureFlags` は suspense: true のため、
 * 親 Screen の Suspense 境界内でレンダーされる必要がある。
 */
const UserListContent: React.FC = () => {
  const threeLetterCode = getThreeLetterCode() ?? '';
  const { data } = useGetPartnerAdminsPartnerFeatureFlags({ threeLetterCode });

  const isBankAccountEnabled = (data.partner_feature_flags ?? []).some(
    f => f.feature_key === 'bank_account' && f.enabled
  );

  return isBankAccountEnabled ? <UserListBankAccount /> : <UserList />;
};

/**
 * 利用者一覧 Screen（新パターン）
 *
 * partner_feature_flag.bank_account が ON の場合は UserListBankAccount を表示し、
 * OFF の場合は既存の UserList を表示する。
 */
export const Screen: React.FC = () => {
  return (
    <>
      <PageHeader variant='title' title='利用者一覧' />
      <main className={styles.body}>
        <Suspense fallback={<Loader />}>
          <UserListContent />
        </Suspense>
      </main>
    </>
  );
};
